import React from 'react'

export default function CustomSchemaManagement() {
  return (
    <div>CustomSchemaManagement</div>
  )
}
